import { useQuery } from '@apollo/client/react/hooks';
import SpinnerMono from '@clearkit/icons/indicators/SpinnerMono';

import ActiveIntegrationCard from './ActiveIntegrationCard';
import activeIntegrationsQuery from './activeIntegrationsQuery.graphql';
import ActiveIntegrationsTimeRangeFilters from './ActiveIntegrationsTimeRangeFilters';

function ActiveIntegrationsList() {
  const { data: { accountConnectors } = {}, loading: loading } = useQuery(
    activeIntegrationsQuery,
    {
      fetchPolicy: 'no-cache',
    },
  );
  return (
    <div className="px-10 py-6">
      <ActiveIntegrationsTimeRangeFilters />
      <h3 className="mb-4 text-base font-medium">Active Integrations</h3>
      {loading ? (
        <SpinnerMono />
      ) : (
        accountConnectors?.map((ac) => (
          <ActiveIntegrationCard key={ac.id} accountConnector={ac} />
        ))
      )}
    </div>
  );
}

export default ActiveIntegrationsList;
